
require('bootstrap-table/src/bootstrap-table.js');
require('bootstrap-table/src/extensions/export/bootstrap-table-export.js');
require('bootstrap-table/src/locale/bootstrap-table-nl-NL.js');
require('bootstrap-table/src/locale/bootstrap-table-en-US.js');

require('./tableExport.min.js');
require('./custom-sort.js');

